import { render, staticRenderFns } from "./GlobalSpinner.vue?vue&type=template&id=21b6c95c&scoped=true"
import script from "./GlobalSpinner.vue?vue&type=script&lang=js"
export * from "./GlobalSpinner.vue?vue&type=script&lang=js"
import style0 from "./GlobalSpinner.vue?vue&type=style&index=0&id=21b6c95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6c95c",
  null
  
)

export default component.exports